import { isAgent, type Role } from '@/data/types'

/**
 * Member List Exposure column: figures only for leaf players; mid-ladder agents
 * render "NA". Totals / mapping still use the numeric exposure.
 */
export function showMemberListExposure(role: Role): boolean {
  return !isAgent(role)
}
